import { Link } from 'react-router-dom';
import { brands } from '@/mocks/brands';

export default function FeaturedBrands() {
  const featuredBrands = brands.filter((b) => b.featured);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            精选推荐
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            国货之光 · 精选品牌
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            我们精心挑选最具代表性的中国自主品牌，展现国货精品的卓越品质与独特魅力
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop>
          {featuredBrands.map((brand) => (
            <Link
              key={brand.id}
              to={`/category/${brand.category}`}
              className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/80"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={brand.image}
                  alt={`${brand.name} - 国产品牌`}
                  title={`${brand.name} - ${brand.slogan}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded">
                    {brand.rating} 分
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-1">
                  {brand.name}
                </h3>
                <p className="text-xs text-foreground-500 mb-2 line-clamp-1">
                  {brand.slogan}
                </p>
                <div className="flex flex-wrap gap-1">
                  {brand.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-secondary-100 text-secondary-800 text-xs rounded"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link
            to="/category/keji-shuma"
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 cursor-pointer"
          >
            查看全部品牌
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}